<div class="resa-section">
  <h3 class="primary-color no-margin"><b>INSCRIPTION</b></h3>
  <div>
    <h2 class="no-margin">{{currentResa ? currentResa.formation.libelle : ''}}</h2>
  </div>
  <ags-kendo-stepper [stepList]="orderSteps"></ags-kendo-stepper>
</div>
